'use client';

export { default } from './Box';
export { default as boxClasses } from './boxClasses';
export * from './boxClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Box/index.js
// module id = 821
// module chunks = 22